import * as ActionTypes from './ActionTypes';
import { IEdit, ISpecialAuthorizationsGroup, ISpecialAuthorization } from './Types';
import IReducerReturn from '../../../store/IReducerReturn';
import SpecialAuthorizationsApi from './SpecialAuthorizationsApi';
import { assign } from '../../../shared/Assign';

function editSucceeded(result: IEdit): IReducerReturn {
    return {
        type: ActionTypes.EDIT_SPECIAL_AUTHORIZATIONS_SUCCESS,
        result: result
    };
}

export function edit(userId: number): any {
    return (dispatch: any, getState: any) =>
        SpecialAuthorizationsApi.edit(userId)
            .then((result: any) => {
                dispatch(editSucceeded(result));
            })
            .catch((error: string) => {
                throw error;
            });
}

function clearSucceeded(): IReducerReturn {
    return { type: ActionTypes.CLEAR_SPECIAL_AUTHORIZATIONS, result: null };
}

export function clear(): any {
    return (dispatch: any, getState: any) => new Promise(() => {}).then(dispatch(clearSucceeded()));
}

function updateSucceeded(): IReducerReturn {
    return {
        type: ActionTypes.UPDATE_SPECIAL_AUTHORIZATIONS_SUCCESS,
        result: null
    };
}

export function update(userId: number, creates: number[], deletes: number[]): any {
    return (dispatch: any, getState: any) =>
        SpecialAuthorizationsApi.update(userId, {
            creates: creates,
            deletes: deletes
        })
            .then((result: any) => {
                dispatch(updateSucceeded());
            })
            .catch((error: string) => {
                throw error;
            });
}
